import React, { useEffect, useRef } from 'react';
import { gsap } from "gsap";

import Beam from '../../../images/pages/cases/robot/beam.png';
import BeamWide from '../../../images/pages/cases/robot/beam-wide.png';
import Robot from '../../../images/pages/cases/robot/robot.png';

const AnimatedRobot = ({locale}) => {
    const blockRef = useRef(null);
    const wrapperRef = useRef(null);
    const robotRef = useRef(null);
    const beamRef = useRef(null);
    const beamWideRef = useRef(null);
    const textBlockRef = useRef(null);
    const markerRef = useRef(null);


    useEffect(() => {
        const tl = gsap.timeline({ repeat: -1 });
        let points = [];

        (locale === 'en' || locale === 'de') ?
            points = [
                {
                    x: 0,
                    y: 0,
                    text: 'Here’s the information you regarding current clinical guidelines. Let me know if you need further details.',
                },
                {
                    x: 0,
                    y: 115,
                    text: 'Based on the details you provided, here’s what I found about interesting clinical cases. Please feel free to ask for clarification if needed',
                },
                {
                    x: 0,
                    y: -100,
                    text: 'To address your question on medication dosage here’s a summary of the relevant information',
                },
                {
                    x: 0,
                    y: 150,
                    text: 'Here’s what I found regarding the following presenting symptoms. Let me know if you need any additional insights or resources.',
                },
            ]:
            points = [
                {
                    x: 0,
                    y: 0,
                    text: 'Voici les informations que vous avez demandées concernant les directives cliniques actuelles. N’hésitez pas à me faire savoir si vous avez besoin de plus de détails.',
                },
                {
                    x: 0,
                    y: 115,
                    text: 'En fonction des éléments que vous avez fournis, voici ce que j’ai trouvé sur des cas cliniques intéressants. N’hésitez pas à demander des précisions si nécessaire.',
                },
                {
                    x: 0,
                    y: -100,
                    text: 'Pour répondre à votre question sur le dosage des médicaments, voici un résumé des informations pertinentes.',
                },
                {
                    x: 0,
                    y: 150,
                    text: 'Voici ce que j’ai trouvé concernant les symptômes présentés. Faites-moi savoir si vous avez besoin d’informations ou de ressources supplémentaires.'
                }
            ];

        gsap.set(robotRef.current, {
            opacity: 1,
        });

        gsap.set(textBlockRef.current, {
            scale: 0,
        });

        points.forEach((point, i) => {
            tl.set(markerRef.current, {
                x: point.x,
                y: point.y,
                opacity: 0,
            });

            tl.set(textBlockRef.current, {
                x: point.x,
                y: point.y,
                textContent: point.text,
                opacity: 0,
                scale: 0,
            });

            tl.set(beamRef.current, {
                x: point.x,
                y: point.y,
                opacity: 0,
            });

            tl.set(beamWideRef.current, {
                x: point.x,
                y: point.y,
                opacity: 0,
            });

            tl.to(robotRef.current, {
                x: point.x,
                y: point.y,
                duration: 1,
                ease: 'power1.inOut',
            });

            tl.addLabel(`start${i}`);

            tl.to(
                markerRef.current,
                {
                    opacity: 1,
                    scale: 2.5,
                    duration: 0.5,
                    ease: 'power1.in',
                },
                `start${i}`,
            );

            tl.to(
                beamRef.current,
                {
                    opacity: 1,
                    duration: 0.5,
                    ease: 'power1.in',
                },
                `start${i}+=0.5`,
            );

            tl.addLabel(`showText${i}`);

            tl.to(
                beamRef.current,
                {
                    opacity: 0,
                    duration: 0.2,
                    ease: 'power1.out',
                },
                '+=1',
            );

            tl.to(
                markerRef.current,
                {
                    opacity: 0,
                    scale: 0,
                    duration: 0.2,
                    ease: 'power1.out',
                },
                '-=0.2',
            );

            tl.to(
                beamWideRef.current,
                {
                    opacity: 1,
                    duration: 0.7,
                    ease: 'power1.in',
                },
                `showText${i}+=0.5`,
            );

            tl.to(
                textBlockRef.current,
                {
                    opacity: 1,
                    scale: 1,
                    duration: 0.5,
                    ease: 'power1.in',
                    transformOrigin: '22% 23%',
                },
                `showText${i}+=0.5`,
            );

            tl.to({}, {}, '+=3');

            tl.addLabel(`closeText${i}`);

            tl.to(markerRef.current, {
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
            });

            tl.to(beamRef.current, {
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
            });

            tl.to(
                beamWideRef.current,
                {
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power1.out',
                },
                `closeText${i}+=1`,
            );

            tl.to(
                textBlockRef.current,
                {
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power1.out',
                },
                `closeText${i}+=1`,
            );

            tl.to({}, {}, '+=0.5');
        });

        tl.to('.robot', {
            x: points[0].x,
            y: points[0].y,
            duration: 1,
            ease: 'power1.inOut',
        });
    }, []);

    return (
        <div className="robot-block" ref={blockRef}>
            <div className="robot-block__img" ref={wrapperRef}></div>
            <img src={Robot} className="robot" alt="Robot" ref={robotRef} />
            <img src={Beam} className="beam" alt="Beam" width="176.5" height="83.5" ref={beamRef} />
            <img src={BeamWide} className="beam-wide" alt="Beam Wide" width="63.5" height="139.5" ref={beamWideRef} />
            <div className="marker" ref={markerRef}></div>
            <div className="text-block" ref={textBlockRef}></div>
        </div>
    );
};

export default AnimatedRobot;

